import api from './api';

export const listUsers = () => api.get('/users');
export const lookupUsers = (query) => api.get('/users/lookup', { params: { q: query } });
export const getAddressBook = () => api.get('/users/address-book');
export const getBlockedUsers = () => api.get('/users/blocked');
export const blockUser = (userId) => api.post('/users/blocked', { userId });
export const unblockUser = (userId) => api.delete(`/users/blocked/${userId}`);